/*
 * Gedrag van het uitklapmenu in de header, op een computer met muis:
 *   - er met de muis overheen  -> het menu klapt open
 *   - erop klikken             -> je gaat naar de pagina zelf
 *   - muis eraf                -> het menu blijft nog even open staan
 *
 * Die laatste regel is nodig omdat er ruim vijftig pixels lege ruimte zit tussen
 * het menu-item in de balk en het paneel dat eronder openklapt. Beweeg je je muis
 * daar naar beneden, dan is hij even "buiten" het menu en klapte het meteen dicht.
 * Daarom sluit het menu nu pas na een korte nawerkingstijd, en wordt dat sluiten
 * afgebroken zodra je muis weer binnen is.
 *
 * Op telefoon en tablet blijft het gewone gedrag: tikken klapt open of dicht.
 * Toetsenbordgebruik blijft ook werken: met Enter klapt het menu open/dicht,
 * want dan is er geen echte muisklik (event.detail is dan 0).
 */
(function () {
  var DESKTOP = '(min-width: 990px)';
  var NAWERKING = 400; // milliseconden dat het menu nog open blijft staan

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  document.querySelectorAll('details.mega-menu').forEach(function (details) {
    var summary = details.querySelector('summary[data-km-mega-link]');
    if (!summary) return;

    var timer = null;

    function stopSluiten() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function openen() {
      stopSluiten();
      if (isDesktop()) details.open = true;
    }

    function straksSluiten() {
      if (!isDesktop()) return;
      stopSluiten();
      timer = setTimeout(function () {
        timer = null;
        details.open = false;
      }, NAWERKING);
    }

    details.addEventListener('mouseenter', openen);
    details.addEventListener('mouseleave', straksSluiten);

    // De muis kan het paneel ook binnenkomen zonder eerst het menu-item te raken;
    // dan moet het sluiten net zo goed worden afgebroken.
    var paneel = details.querySelector('.mega-menu__content');
    if (paneel) {
      paneel.addEventListener('mouseenter', stopSluiten);
      paneel.addEventListener('mouseleave', straksSluiten);
    }

    summary.addEventListener('click', function (event) {
      if (!isDesktop() || event.detail === 0) return;
      event.preventDefault();
      window.location.href = summary.dataset.kmMegaLink;
    });
  });
})();
